import angular from 'angular';
import './config/errorcodes.conf';
import { changePageTitle } from 'auth/actions/session.actions';
import template from './email-notification-templates.html';
import EmailNotificationTemplatesUpdateComponent from './components/update/email-notification-template-update-component';
import EmailNotificationTabComponent from './components/email-notification-tab/email-notification-tab-component';

const DEFAULT_TAB_ID = 'email';

// eslint-disable-next-line no-undef
@Inject('gettextCatalog', '$stateParams')
class EmailNotificationTemplatesController {
  $onInit() {
    this.activeTabId = this.$stateParams.tabId || DEFAULT_TAB_ID;
    this.onTabSelect(this.activeTabId);
  }

  onTabSelect(tabId) {
    this.activeTabId = tabId;
    this.api[tabId].filter.run();
  }
}

class EmailNotificationTemplatesComponent {
  constructor() {
    this.template = template;
    this.controller = EmailNotificationTemplatesController;
    this.bindings = {
      model: '<',
      multilangLocale: '<',
      namespace: '@',
      api: '<',
    };
    return this;
  }
}

export default angular
  .module('email-notification-templates', ['email-notifications-templates-errorcodes', EmailNotificationTabComponent.name])
  .component('emailNotificationTemplateUpdate', new EmailNotificationTemplatesUpdateComponent())
  .component('emailNotificationTemplates', new EmailNotificationTemplatesComponent())
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider
        .state('emailNotificationsTemplates-view', {
          parent: 'arw',
          url: '/email-notifications/templates?tabId',
          params: {
            skipDirtyForms: false,
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Notification Templates')));
              },
            ],
          },
          template: `<email-notification-templates
                        model="appCtrl.appFactory.model"
                        namespace="notificationTemplates"
                        api="$resolve.api"
                       ></email-notifications-templates>`,
          redirectTo: 'permissions-denied',
          resolve: {
            api: [
              'appFactory',
              'appApi',
              (appFactory) => ({
                config: appFactory.deps.config,
                email: {
                  filter: appFactory.dispatch('notificationTemplates.emailGrid.applyFilters', true),
                },
                sms: {
                  filter: appFactory.dispatch('notificationTemplates.smsGrid.applyFilters', true),
                },
                onLanguageSelect: appFactory.dispatch('app.toggleLanguageSelect', true),
                setLanguageValidation: appFactory.actions.app.setLanguageValidation,
              }),
            ],
          },
        })
        .state('emailNotificationsTemplates-update', {
          parent: 'arw',
          url: '/email-notifications/templates/:templateId/update/:templateName',
          template: `<email-notification-template-update
                        app-ctrl="appCtrl"
                        model="appCtrl.appFactory.model"
                        namespace="notificationTemplates"
                        module-name="emailList"
                        api="$resolve.api"
                       ></email-notifications-template-update>`,
          redirectTo: 'permissions-denied',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Edit Notification Template')));
              },
            ],
          },
          resolve: {
            api: [
              'appFactory',
              'appApi',
              (appFactory) => ({
                config: appFactory.deps.config,
                showAlert: appFactory.uiHelpers.showAlert,
                fetchTemplate: appFactory.dispatch('emailNotificationTemplates.fetchTemplate', true),
                updateTemplate: appFactory.dispatch('emailNotificationTemplates.updateTemplate', true),
                onLanguageSelect: appFactory.dispatch('app.toggleLanguageSelect', true),
                initializeForm: appFactory.dispatch('app.initializeForm', true),
                validateForm: appFactory.dispatch('app.validateForm', true),
              }),
            ],
          },
        });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/email-notification-templates-component.js